import React from "react";
import { NavLink } from "react-router-dom"; 
import styled from "styled-components";
//import {FaHouse} from "react-icons/fa6";
import {TrackHeight} from "./TrackSize";
import MenuItem from "./MenuItem";
import Login from "./Login";


const OuterNav = styled.div`
    background: ${({content}) => content.titleBgColor};
    width: max-content;
`;

const Nav = styled.div`
    background: ${({content}) => content.titleBgColor};
    color: ${({content}) => content.titleTextColor};
    display: flex;
    flex-wrap: wrap;
    font-size: 1rem;
    column-gap: 34px;
    row-gap: 10px;
    padding: 10px;
    justify-content: flex-end;
    align-items:flex-end;
    flex-direction: column;
    a { 
        color: ${(props) => props.content.titleTextColor};
        padding: 5px;
    }
`;

const LeftNav = styled.div `
    flex-grow: 1;
    a.active  {
        font-weight: bold;
        color: ${({content}) => content.highlightColor};
        padding: 5px;
        
        
    }
`;


export function LeftNavigation({content, setNavHeight, windowSize}) {

    return(
        <OuterNav content={content.styles}>
            <TrackHeight setSize={setNavHeight} windowSize={windowSize}>
                <LeftNav content={content.styles}>
                    <VerticalNavigation content={content} subItemsEnabled={true}/>
                </LeftNav>
            </TrackHeight>
        </OuterNav>
    )

}

export function VerticalNavigation({content, width='150px', onClick=null, subItemsEnabled=false}) {

    return(
            <Nav content={content.styles}>
                <div></div>
                <NavLink to="/home" onClick={onClick}>Home</NavLink>
                {content.sections.map((item) => {
                    if (content.sectionsEnabled[item]) {
                        if (subItemsEnabled) {
                            return ( <MenuItem key={item} item={item} page={content[item]} styles={content.styles} type='Vertical'/> )
                        } else {
                            return ( <NavLink key={item} to={item}  onClick={onClick} style={{width:width}}>{content[item].title}</NavLink> )
                        }   
                    } else {
                        return null;
                    }
                })}
                <Login link={content.login} styles={content.styles}/>
                <div></div>
            </Nav>
    )
}
